import React, { useCallback, useState } from "react"

import { copyCoords, hasCoords, formatCoords } from "../../helpers/coords"

// Botón-ícono para copiar "lat,lng" al portapapeles, con feedback breve.
// Se usa junto a Origen/Destino, cada escala y el panel de escalas del mapa.
//
// Props:
//   lat, lng  coordenadas (number/string). Si no son válidas, no se renderiza.
//   title     tooltip base (default "Copiar lat,lng").
//   className  clases extra para el <button>.
const CopyCoordsButton = ({ lat, lng, title = "Copiar lat,lng", className = "" }) => {
  const [copied, setCopied] = useState(false)

  const onClick = useCallback(
    async (e) => {
      // Evita disparar el onClick del contenedor (p. ej. "ver en mapa").
      e.preventDefault()
      e.stopPropagation()
      const ok = await copyCoords(lat, lng)
      if (ok) {
        setCopied(true)
        setTimeout(() => setCopied(false), 1500)
      }
    },
    [lat, lng],
  )

  if (!hasCoords(lat, lng)) return null

  const coordsText = formatCoords(lat, lng)
  return (
    <button
      type="button"
      className={`btn btn-link p-0 ms-1 align-baseline ${className}`}
      onClick={onClick}
      title={copied ? "Copiado" : `${title} (${coordsText})`}
      aria-label={title}
    >
      <i className={`bx ${copied ? "bx-check text-success" : "bx-copy text-muted"}`} />
    </button>
  )
}

export default CopyCoordsButton
